import React from 'react'

export default function ConnectLoader() {
    return (
        <div className='mb-4 mx-auto d-flex align-items-center justify-content-center rounded-circle'
            style={{ width: 60, height: 60 }}>
            <div className="connecting-three-body">
                <div className="connecting-three-body__dot"></div>
                <div className="connecting-three-body__dot"></div>
                <div className="connecting-three-body__dot"></div>
            </div>
        </div>
    )
}